import React, { useEffect, useState } from "react";
import SapakimHead from "./SapakimHead";
import { useParams } from "react-router-dom";
import Loading from "../Components/Loading";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../Components/Firebase";

function SViewQuotation() {
  const { CDID, QUID } = useParams();
  const [quotationData, setQuotationData] = useState(null);
  const [customerData, setCustomerData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [modalImage, setModalImage] = useState(null);

  useEffect(() => {
    const fetchQuotationAndCustomer = async () => {
      try {
        const quotationRef = doc(db, "Quotations", QUID);
        const quotationSnap = await getDoc(quotationRef);

        const customerRef = doc(db, "Customers", CDID);
        const customerSnap = await getDoc(customerRef);

        if (quotationSnap.exists()) {
          setQuotationData(quotationSnap.data());
        } else {
          console.warn("המסמך של הבקשה לא נמצא");
        }

        if (customerSnap.exists()) {
          setCustomerData(customerSnap.data());
        } else {
          console.warn("המסמך של הלקוח לא נמצא");
        }
      } catch (err) {
        console.error("שגיאה בשליפת הנתונים:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchQuotationAndCustomer();
  }, [QUID, CDID]);

  const getStatusLabel = (status) => {
    switch ((status || "").toLowerCase()) {
      case "pending":
        return "בהמתנה";
      case "approved":
        return "מאושר";
      case "rejected":
        return "נדחה";
      default:
        return "לא ידוע";
    }
  };

  const openModal = (url) => setModalImage(url);
  const closeModal = () => setModalImage(null);
  
  const handlePrint = () => {
    if (!quotationData) return;

    const typeHebrewMap = {
      Upholsterer: "ריפוד",
      Carpentry: "נגרות",
      sofa: "ספה",
      bed: "מיטה",
      closet: "ארון",
    };

    const totalPriceIncludingVAT = quotationData.items?.reduce((sum, item) => {
      return sum + (item.price ? Number(item.price) : 0);
    }, 0) || 0;

    const totalPriceBeforeVAT = totalPriceIncludingVAT / 1.18;
    const vatAmount = totalPriceIncludingVAT - totalPriceBeforeVAT;
    const hasAnyPrice = quotationData.items?.some(item => item.price);
    const itemCount = quotationData.items?.length || 0;
    const isApproved = (quotationData.QStatus || "").toLowerCase() === "approved";

    const htmlContent = `
<html dir="rtl">
<head>
  <title>הדפסת הצעת מחיר</title>
  <style>
    body {
      font-family: 'Arial', sans-serif;
      direction: rtl;
      background-color: #fff;
      color: #000;
      margin: 20px;
    }
    h1, h2 {
      border-bottom: 2px solid #333;
      padding-bottom: 5px;
    }
    .header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 30px;
    }
    .logo {
      max-height: 150px;
    }
    .quotation-details {
      margin-bottom: 20px;
    }
    .status {
      font-weight: bold;
      padding: 5px 10px;
      border-radius: 5px;
      background: #f0f0f0;
      display: inline-block;
    }
    .status.approved {
      background: #d4edda;
      color: #155724;
      border: 1px solid #c3e6cb;
    }
    table {
      width: 100%;
      border-collapse: collapse;
      page-break-inside: auto;
    }
    th, td {
      text-align: right;
      border: 1px solid #ccc;
      padding: 10px;
      vertical-align: top;
      word-break: break-word;
      white-space: normal;
    }
    tr {
      page-break-inside: avoid;
      page-break-after: auto;
    }
    .full-width-row td {
      background: #f9f9f9;
    }
    img {
      max-width: 80px;
      max-height: 80px;
      margin: 4px;
    }
    .shape-img {
      max-width: 100px;
      border: 1px solid #ccc;
      margin-bottom: 10px;
    }
    .page-break {
      page-break-after: always;
      margin-bottom: 40px;
    }
    .total-section {
      margin-top: 30px;
      padding: 20px;
      border: 2px solid #333;
      background: #f9f9f9;
    }
    .total-section h3 {
      margin-top: 0;
      border-bottom: 1px solid #666;
      padding-bottom: 10px;
    }
    .signature-section {
      margin-top: 30px;
      padding: 20px;
      border: 2px solid #28a745;
      background: #f8f9fa;
      text-align: center;
    }
    .signature-section h3 {
      margin-top: 0;
      color: #28a745;
      border-bottom: 1px solid #28a745;
      padding-bottom: 10px;
    }
    .signature-image {
      max-width: 300px;
      max-height: 150px;
      border: 1px solid #ddd;
      border-radius: 8px;
      margin: 10px 0;
      background: white;
      padding: 10px;
    }
    .approval-details {
      margin-top: 15px;
      font-size: 14px;
      color: #666;
    }
    @media print {
      body {
        margin: 0;
      }
      .header {
        page-break-inside: avoid;
      }
      .page-break {
        page-break-after: always;
      }
      .signature-section {
        page-break-inside: avoid;
      }
    }
  </style>
</head>
<body>
  ${quotationData.items?.map((item, index) => `
    <div class="page-break">
      <div class="header">
        <div>
          <h1>הצעת מחיר מספר ${quotationData.orderNumber} - פריט ${index + 1}</h1>
          <p class="status ${isApproved ? 'approved' : ''}">סטטוס: ${getStatusLabel(quotationData.QStatus)}</p>
        </div>
        <div>
          <img src="https://firebasestorage.googleapis.com/v0/b/milaaz-4538e.firebasestorage.app/o/Logo%2FMilaaz1.png?alt=media&token=24f09477-3d96-4419-af28-4978ceb04997" alt="Logo" class="logo" />
        </div>
      </div>

      <div class="quotation-details">
        ${customerData?.Name ? `<p><strong>שם לקוח:</strong> ${customerData.Name}</p>` : ""}
        ${customerData?.Email ? `<p><strong>אימייל:</strong> ${customerData.Email}</p>` : ""}
        ${customerData?.PhoneNumber ? `<p><strong>טלפון:</strong> ${customerData.PhoneNumber}</p>` : ""}
        ${quotationData.createdAt ? `<p><strong>תאריך יצירה:</strong> ${quotationData.createdAt.toDate().toLocaleString()}</p>` : ""}
        ${isApproved && quotationData.approvalDate ? `<p><strong>תאריך אישור:</strong> ${new Date(quotationData.approvalDate.seconds * 1000).toLocaleString()}</p>` : ""}
      </div>

      <h2>פרטי מוצר</h2>
      <table>
        <thead>
          <tr>
            <th>מס'</th>
            ${item.name ? "<th>שם</th>" : ""}
            ${item.type ? "<th>סוג</th>" : ""}
            ${item.fabricManufacturer ? "<th>חברה</th>" : ""}
            ${item.fabricCode ? "<th>מספר חומר</th>" : ""}
            ${item.width ? "<th>רוחב 1</th>" : ""}
            ${item.width2 ? "<th>רוחב 2</th>" : ""}
            ${item.width3 ? "<th>רוחב 3</th>" : ""}
            ${item.height ? "<th>גובה</th>" : ""}
            ${item.depth ? "<th>עומק</th>" : ""}
            ${item.price ? "<th>מחיר</th>" : ""}
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>1</td>
            ${item.name ? `<td>${item.name}</td>` : ""}
            ${item.type ? `<td>${typeHebrewMap[item.type] || item.type}</td>` : ""}
            ${item.fabricManufacturer ? `<td>${item.fabricManufacturer}</td>` : ""}
            ${item.fabricCode ? `<td>${item.fabricCode}</td>` : ""}
            ${item.width ? `<td>${item.width} ס״מ</td>` : ""}
            ${item.width2 ? `<td>${item.width2} ס״מ</td>` : ""}
            ${item.width3 ? `<td>${item.width3} ס״מ</td>` : ""}
            ${item.height ? `<td>${item.height} ס״מ</td>` : ""}
            ${item.depth ? `<td>${item.depth} ס״מ</td>` : ""}
            ${item.price ? `<td>₪${Number(item.price).toLocaleString()}</td>` : ""}
          </tr>
          <tr class="full-width-row">
            <td colspan="${2 
              + (item.name ? 1 : 0) 
              + (item.type ? 1 : 0) 
              + (item.fabricManufacturer ? 1 : 0) 
              + (item.fabricCode ? 1 : 0) 
              + (item.width ? 1 : 0) 
              + (item.width2 ? 1 : 0) 
              + (item.height ? 1 : 0) 
              + (item.depth ? 1 : 0)
              + (item.price ? 1 : 0)
            }">
              ${item.description ? `<p><strong>תיאור:</strong> ${item.description}</p>` : ""}
              ${item.woodType ? `<p><strong>סוג עץ:</strong> ${item.woodType}</p>` : ""}
              ${item.notes ? `<p><strong>הערות:</strong> ${item.notes}</p>` : ""}
              ${item.deliveryDate ? `<p><strong>תאריך אספקה:</strong> ${new Date(item.deliveryDate).toLocaleDateString()}</p>` : ""}
              ${item.shapeUrl ? `<div><strong>צורת פריט:</strong><br><img src="${item.shapeUrl}" alt="צורת פריט" class="shape-img" /></div>` : ""}
              <div>${(item.images || []).map(url => `<img src="${url}" alt="תמונה" />`).join("")}</div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  `).join("")}

  ${hasAnyPrice ? `
    <div class="total-section">
      <h3>סיכום מחירים - הצעת מחיר מספר ${quotationData.orderNumber} (${itemCount} פריטים)</h3>
      <p><strong>סה״כ כולל מע״מ:</strong> ₪${totalPriceIncludingVAT.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p>
      <p><strong>סה״כ לפני מע״מ:</strong> ₪${totalPriceBeforeVAT.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p>
      <p><strong>מע״מ (18%):</strong> ₪${vatAmount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p>
    </div>
  ` : ""}

  ${isApproved && quotationData.signature ? `
    <div class="signature-section">
      <h3>חתימה דיגיטלית - אישור הצעת מחיר</h3>
      <img src="${quotationData.signature}" alt="חתימה דיגיטלית" class="signature-image" />
      <div class="approval-details">
        <p><strong>הצעת מחיר זו אושרה באופן דיגיטלי</strong></p>
        ${quotationData.approvalDate ? `<p>תאריך אישור: ${new Date(quotationData.approvalDate.seconds * 1000).toLocaleString()}</p>` : ""}
      </div>
    </div>
  ` : ""}

  <script>
    window.onload = function() {
      window.print();
      setTimeout(() => window.close(), 1000);
    };
  </script>
</body>
</html>
`;

    const printWindow = window.open("", "_blank", "width=800,height=600");
    if (!printWindow) return;
    printWindow.document.open();
    printWindow.document.write(htmlContent);
    printWindow.document.close();
  };

  if (loading) return <Loading />;

  if (!quotationData) {
    return <div className="p-4 text-red-500 font-semibold">הבקשה לא נמצאה או התרחשה שגיאה.</div>;
  }

  const totalPriceIncludingVAT = quotationData.items?.reduce((sum, item) => {
    return sum + (item.price ? Number(item.price) : 0);
  }, 0);

  const totalPriceBeforeVAT = totalPriceIncludingVAT / 1.18;
  const vatAmount = totalPriceIncludingVAT - totalPriceBeforeVAT;

  const hasAnyPrice = quotationData.items?.some(item => item.price);
  const isApproved = (quotationData.QStatus || "").toLowerCase() === "approved";

  return (
    <React.Fragment>
      <SapakimHead />
      <div className="sview-container" dir="rtl">
        <div className="sview-header-actions" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
          <h1 className="sview-title" style={{ margin: 0 }}>פרטי בקשת הצעת מחיר</h1>
          <button 
            onClick={handlePrint}
            className="print-button"
            style={{
              backgroundColor: '#007bff',
              color: 'white',
              border: 'none',
              padding: '10px 20px',
              borderRadius: '5px',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: 'bold'
            }}
            onMouseOver={(e) => e.target.style.backgroundColor = '#0056b3'}
            onMouseOut={(e) => e.target.style.backgroundColor = '#007bff'}
          >
            🖨️ הדפס
          </button>
        </div>

        <div className="sview-section">
          <p>
            <span className="sview-label">סטטוס:</span> 
            <span style={{
              backgroundColor: isApproved ? '#d4edda' : '#f8f9fa',
              color: isApproved ? '#155724' : '#495057',
              padding: '4px 8px',
              borderRadius: '4px',
              border: isApproved ? '1px solid #c3e6cb' : '1px solid #dee2e6',
              marginRight: '8px',
              fontWeight: 'bold'
            }}>
              {getStatusLabel(quotationData.QStatus)}
            </span>
          </p>
          <p>
            <span className="sview-label">נוצר בתאריך:</span>{" "}
            {quotationData.createdAt?.toDate?.().toLocaleString() || "לא זמין"}
          </p>
          {isApproved && quotationData.approvalDate && (
            <p>
              <span className="sview-label">אושר בתאריך:</span>{" "}
              {quotationData.approvalDate?.toDate?.().toLocaleString() || 
               new Date(quotationData.approvalDate.seconds * 1000).toLocaleString()}
            </p>
          )}
          <p><span className="sview-label">מספר בקשה:</span> {quotationData.orderNumber}</p>

          {quotationData.items?.map((item, index) => (
            <p key={index}>
              <span className="sview-label">תאריך אספקה עבור פריט {index + 1}:</span>{" "}
              {item.deliveryDate
                ? new Date(item.deliveryDate).toLocaleDateString()
                : "לא נבחר"}
            </p>
          ))}
        </div>

        {customerData && (
          <>
            <h2 className="sview-subtitle">פרטי לקוח</h2>
            <div className="sview-section">
              <p><span className="sview-label">שם:</span> {customerData.Name}</p>
              <p><span className="sview-label">אימייל:</span> {customerData.Email}</p>
              <p><span className="sview-label">טלפון:</span> {customerData.PhoneNumber}</p>
            </div>
          </>
        )}

        <h2 className="sview-subtitle">פריטים בבקשה</h2>
        {quotationData.items?.map((item, index) => (
          <div key={index} className="sview-item">
            <p><span className="sview-label">שם:</span> {item.name}</p>
            <p><span className="sview-label">תיאור:</span> {item.description}</p>
            <p><span className="sview-label">סוג:</span> {item.type}</p>
            {item.fabricCode && <p><span className="sview-label">קוד בד:</span> {item.fabricCode}</p>}
            {item.fabricManufacturer && <p><span className="sview-label">יצרן בד:</span> {item.fabricManufacturer}</p>}
            {item.woodType && <p><span className="sview-label">סוג עץ:</span> {item.woodType}</p>}
            {item.width && <p><span className="sview-label">רוחב 1:</span> {item.width} ס״מ</p>}
            {item.width2 && <p><span className="sview-label">רוחב 2:</span> {item.width2} ס״מ</p>}
            {item.width3 && <p><span className="sview-label">רוחב 3:</span> {item.width3} ס״מ</p>}
            {item.height && <p><span className="sview-label">גובה:</span> {item.height} ס״מ</p>}
            {item.depth && <p><span className="sview-label">עומק:</span> {item.depth} ס״מ</p>}
            {item.notes && <p><span className="sview-label">הערות:</span> {item.notes}</p>}
            <p>
              <span className="sview-label">מחיר:</span>{" "}
              {item.price ? `₪${Number(item.price).toLocaleString()}` : "לא זמין"}
            </p>

            {item.shapeUrl && (
              <div className="sview-shape-preview">
                <p><span className="sview-label">תמונה של הצורה:</span></p>
                <img
                  src={item.shapeUrl}
                  alt="צורת המוצר"
                  style={{ maxWidth: "120px", marginTop: "8px" }}
                />
              </div>
            )}

            {item.images?.length > 0 && (
              <div className="sview-images">
                {item.images.map((url, i) => (
                  <img
                    key={i}
                    src={url}
                    alt={`תמונה ${i + 1}`}
                    onClick={() => openModal(url)}
                    style={{ cursor: "pointer", maxWidth: "100px", marginRight: "8px" }}
                  />
                ))}
              </div>
            )}
          </div>
        ))}

        {hasAnyPrice && (
          <div className="sview-total-price mt-6 text-lg font-semibold space-y-1">
            <p className="font-bold text-xl mb-2">
              סה״כ כולל מע״מ: ₪{totalPriceIncludingVAT.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
            </p>
            <p>סה״כ לפני מע״מ: ₪{totalPriceBeforeVAT.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p>
            <p>מע״מ (18%): ₪{vatAmount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p>
          </div>
        )}

        {/* Digital Signature Section */}
        {isApproved && quotationData.signature && (
          <div style={{
            marginTop: '30px',
            padding: '20px',
            border: '2px solid #28a745',
            borderRadius: '10px',
            backgroundColor: '#f8f9fa',
            textAlign: 'center'
          }}>
            <h2 style={{
              color: '#28a745',
              marginTop: '0',
              borderBottom: '2px solid #28a745',
              paddingBottom: '10px',
              marginBottom: '20px'
            }}>
              חתימה דיגיטלית - אישור הצעת מחיר
            </h2>
            
            <div style={{
              display: 'flex',
              justifyContent: 'center',
              marginBottom: '15px'
            }}>
              <img 
                src={quotationData.signature} 
                alt="חתימה דיגיטלית" 
                style={{
                  maxWidth: '300px',
                  maxHeight: '200px',
                  border: '1px solid #ddd',
                  borderRadius: '8px',
                  backgroundColor: 'white',
                  padding: '15px',
                  boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
                  cursor: 'pointer'
                }}
                onClick={() => openModal(quotationData.signature)}
              />
            </div>
            
            <div style={{
              fontSize: '14px',
              color: '#666'
            }}>
              <p style={{ fontWeight: 'bold', marginBottom: '5px' }}>
                ✅ הצעת מחיר זו אושרה באופן דיגיטלי
              </p>
              {quotationData.approvalDate && (
                <p>
                  תאריך אישור: {quotationData.approvalDate?.toDate?.().toLocaleString() || 
                  new Date(quotationData.approvalDate.seconds * 1000).toLocaleString()}
                </p>
              )}
            </div>
          </div>
        )}

        {modalImage && (
          <div className="modal-overlay" onClick={closeModal}>
            <img
              src={modalImage}
              alt="תמונה מוגדלת"
              style={{
                maxHeight: "90%",
                maxWidth: "90%",
                boxShadow: "0 0 15px white",
                cursor: "default"
              }}
              onClick={(e) => e.stopPropagation()}
            />
          </div>
        )}
      </div>
      
      <style jsx>{`
        @media print {
          .print-button {
            display: none !important;
          }
          .modal-overlay {
            display: none !important;
          }
          .sview-images img {
            max-width: 150px !important;
            page-break-inside: avoid;
          }
          .sview-item {
            page-break-inside: avoid;
            margin-bottom: 20px;
          }
          .sview-container {
            max-width: none !important;
            margin: 0 !important;
            padding: 20px !important;
          }
        }
      `}</style>
    </React.Fragment>
  );
}

export default SViewQuotation;